import { GET_STATES } from './../constants';
import { handleActions } from "redux-actions"

export const states  = handleActions(
  {
    [ GET_STATES ]: (state, action) => action.payload,
  }, []
)